import { CCol, CContainer, CImage, CRow } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setDashboardInProgressState } from '../../../../redux/encounters/encountersSlice'
import { format } from 'date-fns'
import { FUSION_URL } from '../../../../apiHelper/helper.js'
import { callFusion } from '../../../../redux/encounters/encountersThunk'
import { hasAdminRole } from '../../../../components/common/shared/sharedRoleLogic'

export default function InProgressQuickView() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [inProgressVisits, setInProgressVisits] = useState([])
  const [inProgressVisitCount, setInProgressVisitCount] = useState(0)
  const roles = useSelector((state) => state?.user?.roles) || []

  useEffect(() => {
    const fetchInProgressEncounters = async () => {
      try {
        const response = await callFusion(`${FUSION_URL}v1/encounter/list`, {
          filter: {
            encounter_statuses: ['in-progress'],
          },
          sort: {
            service_date_from: 1,
          },
          limit: 3,
          page: 1,
          scope: 'practice',
        })

        if (response?.status === 200) {
          setInProgressVisits(response?.data?.encounters || [])
          setInProgressVisitCount(response?.data?.pagination?.record_count || 0)
        }
      } catch (error) {
        console.error('Error fetching dashboard in progress encounters:', error)
      }
    }

    fetchInProgressEncounters()
  }, [])

  return (
    <div
      className="providerholds-container"
      style={{
        marginBottom: '24px',
      }}
    >
      <div className="header-container">
        <span className="providerholds-heading">In Progress</span>
        <div className="notification-icon-container">
          <div className="notification-number">{inProgressVisitCount}</div>
        </div>
      </div>
      <div className="subheading-container pt-2">
        <span className="providerholds-subheading"></span>
        {inProgressVisits?.length > 0 && (
          <span
            className="provider-seeall-link"
            onClick={() => {
              dispatch(setDashboardInProgressState(hasAdminRole(roles)))
              navigate('/encounters')
            }}
          >
            See In Progress Encounters
          </span>
        )}
      </div>
      {inProgressVisits?.length > 0 ? (
        inProgressVisits.map((item, index) => (
          <div key={index}>
            <InProgressTile item={item} />
          </div>
        ))
      ) : (
        <div className="noresult-found">
          <p>No In Progress encounters found</p>
        </div>
      )}
    </div>
  )
}

const InProgressTile = ({ item }) => {
  return (
    <div className="issuescard-container mt-2">
      <CContainer>
        <CRow>
          <CCol sm="2" className="px-0">
            <div className="issuescard-icon-container m-0">
              <div className="icon-wrapper">
                <CImage className="notification-icon" src={''} />
              </div>
            </div>
          </CCol>

          <CCol sm="10">
            <div className="issuescard-data-container">
              <span className="issuescard-heading">
                {item?.patient_lastname}, {item?.patient_firstname}{' '}
                {item?.patient_dob &&
                  format(new Date(item?.patient_dob?.replaceAll('-', '/')), 'MM/dd/yyyy')}
              </span>
              <span className="issuescard-subheading">{item?.facility_name}</span>
              <span className="issuescard-subheading">
                {item?.service_date_from &&
                  format(new Date(item?.service_date_from?.replaceAll('-', '/')), 'MM/dd/yyyy')}
              </span>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
